import { render, staticRenderFns } from "./ExtensionSearch.vue?vue&type=template&id=70f4a9ac&"
import script from "./ExtensionSearch.vue?vue&type=script&lang=ts&"
export * from "./ExtensionSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports